import React, { useMemo, useState, useEffect, useReducer } from "react";
import { UncontrolledTooltip, Badge } from "reactstrap";
import * as d3 from "d3";
import styled from "styled-components";



const Path = styled.path`
  fill: ${(props) => props.color};
  cursor: pointer;
  stroke: "white";
  filter:${(props) => props.hovered ? "url(#dropshadow)" : ""};
`;



function useDrillableData(data, props) {
  const initialState = {
    renderData: data,
    stack: [],
    startAngle: 0
  };

  return useReducer((state, action) => {
    switch (action.type) {
      case "drilldown":
        return {
          renderData: state.renderData[action.index].subRows,
          stack: [...state.stack, state.renderData],
          startAngle: action.startAngle
        };
      case "drillup":
        if (state.stack.length > 0) {
          return {
            renderData: state.stack.slice(-1)[0],
            stack: state.stack.slice(0, -1),
            startAngle: state.startAngle
          };
        } else {
          return state;
        }
      default:
        return state;
    }
  }, initialState);
}

const PieChartD3 = (props) => {
  const { dims, data } = props.component;
  let { chartData, colors } = data;
  const [{ renderData, startAngle }, dispatch] = useDrillableData(chartData, props);
  const [percentVisible, setPercentVisible] = useState(0);



  const Arc = ({ arcData, onClick, chartRadius, color }) => {

    let [innerRadius, setInnerRadius] = useState(12);
    let [outerRadius, setOuterRadius] = useState(chartRadius);
    let [hovered, setHovered] = useState(false);
    let anim = chartRadius * .08;

    const mouseOver = (e) => {
      setInnerRadius(innerRadius + anim / 2);
      setOuterRadius(outerRadius + anim);
      setHovered(true);
    }

    const mouseOut = () => {
      setInnerRadius(innerRadius - anim / 2);
      setOuterRadius(outerRadius - anim);
      setHovered(false);
    }

    const arc = d3
      .arc()
      .innerRadius(innerRadius)
      .outerRadius(outerRadius);

    return (
      <Path
        d={arc(arcData)}
        color={color}
        onMouseOver={(e) => mouseOver(e, arcData)}
        onMouseOut={mouseOut}
        onClick={() => onClick(arcData)}
        hovered={hovered}
      />
    )
  }

  const pie = d3
    .pie()
    .startAngle(startAngle)
    .endAngle(startAngle + percentVisible * Math.PI * 2)
    .value((d) => d.value);

  function drilldown({ startAngle, index, data }) {
    let { clickedSlice, clickedSliceLast } = props.parentState;

    if (data.subRows) {
      props.liftGlobalState({ name: 'clickedSlice' }, data.rowdata.row_id);
      dispatch({ type: "drilldown", index, startAngle });
    } else {
      props.liftGlobalState({ name: 'clickedSliceLast' }, data.rowdata.row_id);
    }
  }

  function drillup() {
    let { clickedSlice, clickedSliceLast } = props.parentState;
    if (clickedSliceLast) {
      console.log({ clickedSliceLast });
      props.liftGlobalState({ name: 'clickedSliceLast' }, false);
    } else {
      if (clickedSlice) {
        console.log({ clickedSlice });
        let t = clickedSlice.replace("grp_", '').split('_');
        t.pop();
        t = t.join('_');
        console.log({ t });
        props.liftGlobalState({ name: 'clickedSlice' }, t);
      }
    }
    dispatch({ type: "drillup" });
  }

  useEffect(() => {
    d3.selection()
      .transition("pie-reveal")
      // .duration(1000)
      .ease(d3.easeSinInOut)
      .tween("percentVisible", () => {
        const percentInterpolate = d3.interpolate(0, 100);
        return (t) => setPercentVisible(percentInterpolate(t));
      });
  }, [renderData]);



  let { conditionalRender } = props;

  let wdt = props.component.widths.parent.split('-');
  let blocks = parseInt(wdt[wdt.length - 1]);
  let svgwidth = dims.cw ? blocks * dims.cw : 400;
  let svgheight = dims.ch ? blocks * dims.ch : 400;

  let mindim = Math.min(svgwidth, svgheight);
  let chartRadius = mindim * 0.45; // less than half of min dimension of the chart container. Otherwise pie chart will go outside the container.


  return (
    <div className={`form-group ${props.component.widths.parent} `} >
      {conditionalRender && conditionalRender != 'blank' &&
        <svg width={svgwidth} height={svgheight} style={{}}>
          {/* transform - Starting point of all the diagrams in <g group, relative to <svg   */}
          <g transform={`translate(${svgwidth / 2}, ${svgheight / 2})`}>
            <defs>
              <filter id="dropshadow" height="130%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="2" />
                <feOffset dx="2" dy="2" result="offsetblur" />
                <feMerge>
                  <feMergeNode />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>

            {pie(renderData).map((ad, idx) => {
              return (
                <Arc arcData={ad} key={idx} color={colors[idx]} onClick={drilldown} chartRadius={chartRadius} />
              )
            }
            )}
            <circle cx="0" cy="0" r="10" strokeWidth="0" fill="#d54062" onClick={drillup} />
          </g>
        </svg>
      }
    </div>
  );
}

export default PieChartD3;
